import { Container, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { MetaTags } from 'components/common';

const useStyles = makeStyles(() => ({
  PrivacyPolicyBg: {
    display: 'block',
    padding: '50px 0',
    '& h5': {
      fontSize: 12,
      marginBottom: '0px',
    },
    '& ul': {
      marginBottom: '20px',
      '& li': {
        fontSize: 11,
        listStyle: 'disc',
        marginLeft: '30px',
        marginBottom: '-5px',
      },
    },
    '& p': {
      fontSize: 11,
      marginBottom: '1rem',
      '& span': {
        fontWeight: 700,
      },
    },
  },
}));

function PrivacyPolicy() {
  const classes = useStyles();

  return (
    <>
      <MetaTags
        title="Privacy Policy - POD"
        description="Privacy Policy"
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="pod podworld privacy policy"
      />
      <div className={classes.PrivacyPolicyBg}>
        <Container maxWidth="lg">
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <h3>Privacy Policy </h3>
              <Typography variant="body1">
                This privacy policy (&quot;Policy&quot;) will help you
                understand how Crowdpouch Ventures Services Private Limited
                (&quot;Owner&quot; &quot;us&quot;, &quot;we&quot;,
                &quot;our&quot;) uses and protects the data you provide to us
                when you visit and use POD (&quot;Platform&quot;,
                &quot;service&quot;).
              </Typography>

              <Typography variant="body1">
                We reserve the right to change this Policy at any given time, of
                which you will be promptly updated. If you want to make sure
                that you are up to date with the latest changes, we advise you
                to frequently visit this page.
              </Typography>

              <h5>What User Data We Collect</h5>
              <Typography variant="body1">
                When you visit the Platform, we may collect the following data:
              </Typography>
              <ul>
                <li>Your IP address</li>
                <li>Your contact information and email address</li>
                <li>Other information such as interests and preferences</li>
                <li>
                  Data profile regarding your online behavior on our Platform
                </li>
              </ul>

              <h5>Why We Collect Your Data</h5>
              <Typography variant="body1">
                We are collecting your data for several reasons:
              </Typography>
              <ul>
                <li>To better understand your needs</li>
                <li>To improve our services</li>
                <li>
                  To send you promotional emails containing the information we
                  think you will find interesting
                </li>
                <li>
                  To contact you to fill out surveys and participate in other
                  types of market research
                </li>
                <li>
                  To customize our Platform according to your online behavior
                  and personal preferences
                </li>
              </ul>

              <h5>Safeguarding and Securing the Data</h5>
              <Typography variant="body1">
                We are committed to securing your data and keeping it
                confidential. The Owner has done all in its power to prevent
                data theft, unauthorized access, and disclosure by implementing
                the latest technologies and software, which help us safeguard
                all the information we collect online.
              </Typography>

              <h5>Our Cookie Policy</h5>
              <Typography variant="body1">
                Once you agree to allow our Platform to use cookies, you also
                agree to use the data it collects regarding your online behavior
                (analyze web traffic, web pages you spend the most time on, and
                Platforms you visit). <br></br>
                The data we collect by using cookies is used to customize our
                Platform to your needs. After we use the data for statistical
                analysis, the data is completely removed from our systems.
                <br></br>
                Please note that cookies don&apos;t allow us to gain control of
                your computer in any way. They are strictly used to monitor
                which pages you find useful and which you do not so that we can
                provide a better experience for you.<br></br>
                If you want to disable cookies, you can do it by accessing the
                settings of your internet browser. (Provide links for cookie
                settings for major internet browsers).<br></br>
              </Typography>

              <h5>Amendment or Changes to our Privacy Policy</h5>
              <Typography variant="body1">
                We, with or without any notice to you, at our sole discretion
                from time to time may change, update and modify this Privacy
                Policy, so that they accurately reflect our Services and
                policies. You agree that the Owner has the right to modify and
                amend the Privacy Policy and it shall be in full force and
                effective immediately from the day it is posted on the Platform
                and the amendments shall replace any previous version of the
                Privacy Policy on the Platform.
              </Typography>

              <h5>Thirdparty&apos;s Link</h5>
              <Typography variant="body1">
                Our Platform contains links that lead to other websites. If you
                click on these links, the Owner is not held responsible for your
                data and privacy protection. Visiting those platforms or
                websites is not governed by this Privacy Policy agreement. Make
                sure to read the privacy policy documentation of the platform or
                website you go to or redirected to from our Platform.
              </Typography>

              <h5>Payment Details</h5>
              <Typography variant="body1">
                All payment shall be made through Razorpay and in respect to any
                credit card, debit card or other payment processing details
                provided to Razorpay by you, Razorpay shall be liable to secure
                the confidential details; kindly check{' '}
                <a href="https://razorpay.com" target="_blank" rel="noreferrer">
                  https://razorpay.com
                </a>{' '}
                privacy policy. We shall not be held liable for any loss nor do
                we collect or store any of the confidential information with
                respect to your payment details.
              </Typography>

              <h5>Restricting the Collection of your Personal Data</h5>
              <Typography variant="body1">
                The Owner will not lease, sell or distribute your personal
                information to any third parties, might do so to the extent
                necessary to comply with any requirement of any regulatory body,
                applicable law or regulation binding on it. Your personal
                information will be used when we need to send you promotional
                materials if you agree to this Privacy Policy.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}

export default PrivacyPolicy;
